import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import TextInput from "../../../../../../../merchant/panel/scripts/shared/input/textinput.js";
import executeRequest from "../../../../../modules/request.js";
import Button from "../../../../../shared/ui/inputs/classicButton.js";
import "./login.css";
import { toast } from "react-toastify";
import InfoAfterLogin from "../infoAfterLogin/infoAfterLogin.js";
import { emailReqexp } from "../../../../../../api/public/users/createAccount.js";
import FlowDisplay from "../../../../../../../merchant/panel/scripts/shared/FlowDisplayer/FlowDisplayer.js";
//we do It in order to provide compatibility with merchants panel
const defaultToastOptions = {
    position: "top-left",
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    autoClose: 9000,
};
export default function Login(props) {
    var _a, _b, _c, _d, _e, _f;
    const overrides = (_a = props.flow) === null || _a === void 0 ? void 0 : _a.overrides;
    const needsPhone = (_b = overrides === null || overrides === void 0 ? void 0 : overrides.requiresPhone) !== null && _b !== void 0 ? _b : props.needsPhone;
    if (props.needsEmail == false &&
        props.needsEmail == false &&
        needsPhone == false) {
        props.onLogin();
    }
    const loginType = (_c = props.loginType) !== null && _c !== void 0 ? _c : "register";
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [error, setError] = useState("");
    const [openedLoginChooser, setOpenedLoginChooser] = useState(false);
    const [form, setForm] = FlowDisplay.useForm(0, props.componentList, {});
    useEffect(() => {
        sessionStorage.setItem("name", name);
        sessionStorage.setItem("email", email);
        sessionStorage.setItem("phone", phone);
    }, [name, email, phone]);
    async function handleCreatingNewOrder(count = 2) {
        if (props.disableLogin === true)
            return;
        const result = await executeRequest("/api/public/users/gallery/register", "POST", {
            name: sessionStorage.getItem("name") + "#" + count,
            email: sessionStorage.getItem("email"),
            phone: sessionStorage.getItem("phone"),
            form,
        });
        if (result.status == 409)
            return await handleCreatingNewOrder(count + 1);
        return;
    }
    async function openOrderFromSessionStorage() {
        if (props.disableLogin === true)
            return 400;
        if (props.allowLoginToOrder === false)
            return 409;
        const result = await executeRequest("/api/public/users/gallery/register", "POST", {
            name: sessionStorage.getItem("name"),
            email: sessionStorage.getItem("email"),
            phone: sessionStorage.getItem("phone"),
            form,
        });
        if (result.status == 409) {
            return 409;
        }
        if (result.status === 400) {
            return 400;
        }
        return 200;
    }
    if (openedLoginChooser)
        return (React.createElement(InfoAfterLogin, { allowLoginToOrder: props.allowLoginToOrder, onOpenOldOrder: async () => {
                await openOrderFromSessionStorage();
                toast.success("Poprawnie zalogowano na istniejące zamówienie", defaultToastOptions);
                sessionStorage.setItem("logged", "true");
                props.onLogin();
                props.onExit();
            }, onExit: async () => {
                await executeRequest("/api/public/users/gallery/logout", "GET", {});
                props.onExit();
            }, onCreateNewOrder: async () => {
                await handleCreatingNewOrder();
                toast.success("Utworzono nowe zamówienie!", defaultToastOptions);
                sessionStorage.setItem("logged", "true");
                props.onLogin();
                props.onExit();
            } }));
    const content = (React.createElement("div", { className: "login-container" +
            (props.showWithoutPortal === true ?
                " login-container-without-portal"
                : ""), onClick: () => {
            props.onExit();
        } },
        React.createElement("div", { className: "login-box", onClick: (event) => event.stopPropagation() },
            React.createElement("div", { className: "login-inputs-container", onClick: (event) => event.stopPropagation() },
                "Prosimy o",
                " ",
                loginType === "login" ?
                    "podanie danych logowania"
                    : "zarejestrowanie się",
                ":",
                props.needsName && (React.createElement(TextInput, { label: "Imię i nazwisko", classNames: "input-labels", datatype: "name", name: "fname", onChange: (newValue) => {
                        setName(newValue);
                    } })),
                props.needsEmail && (React.createElement(TextInput, { label: "Adres email", classNames: "input-labels", validator: (value) => {
                        const isValid = emailReqexp.test(value);
                        return [
                            isValid,
                            isValid ? "" : (React.createElement("span", { style: { color: "red" } }, "Nieprawid\u0142owy adres email")),
                        ];
                    }, onChange: (newValue, isValid) => {
                        if (isValid) {
                            setEmail(newValue.trim());
                        }
                    } })),
                needsPhone && (React.createElement(TextInput, { label: "Numer telefonu", classNames: "input-labels", name: "phone", onChange: (newValue) => {
                        setPhone(newValue);
                    } })),
                React.createElement(FlowDisplay, { components: (_e = (_d = props === null || props === void 0 ? void 0 : props.flow) === null || _d === void 0 ? void 0 : _d.extras) === null || _e === void 0 ? void 0 : _e.map((uuid) => props.componentList[uuid]), inputState: form, onChange: setForm, outlinedComponent: props.outlinedComponent, componentsList: (_f = props.componentList) !== null && _f !== void 0 ? _f : {} })),
            React.createElement(Button, { text: "Zatwierd\u017A", value: "add_client_data", onClick: async (event) => {
                    event.stopPropagation();
                    if (name == "" ||
                        email == "" ||
                        (needsPhone === true && phone == "")) {
                        setError("Wszystkie pola muszą być wypełnione");
                        return;
                    }
                    const status = await openOrderFromSessionStorage();
                    if (status === 200) {
                        sessionStorage.setItem("logged", "true");
                        props.onLogin();
                        props.onExit();
                        return;
                    }
                    if (status === 400) {
                        setError("Podano nieprawidłowe wartości");
                        return;
                    }
                    setOpenedLoginChooser(true);
                } }),
            React.createElement("span", { style: { color: "red" } }, error))));
    if (props.showWithoutPortal === true)
        return content;
    return ReactDOM.createPortal(content, document.querySelector("#login-container"));
}
